var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { VERSION } from "../../constants/env";
import { LogLevel } from "../../constants/sdk";
import { getDeviceInfo } from "../../utils/DeviceUtil";
import MonitorModule from "../monitor-module";
import BaseLoggingModule from "./BaseLoggingModule";
class LoggingModule extends BaseLoggingModule {
  constructor() {
    super();
    this._monitorModule = new MonitorModule();
    this._isInitialized = false;
    this.region = "";
    this.bid = "";
    this.debug = false;
    if (!LoggingModule._instance) {
      LoggingModule._instance = this;
    }
    return LoggingModule._instance;
  }
  init(config) {
    if (this._isInitialized) {
      return;
    }
    this._monitorModule.init(config);
    const { region = "", bid = "", appId, debug = false, modules } = config != null ? config : {};
    this.appId = appId;
    this.region = region;
    this.bid = bid;
    this.debug = debug;
    const customLoggingModule = modules == null ? void 0 : modules.logging;
    if (customLoggingModule && customLoggingModule instanceof BaseLoggingModule) {
      this._customLogger = customLoggingModule;
    } else {
      this.warn("[LoggingModule]: init - incorrect implementation of LoggingModule");
    }
    this._isInitialized = true;
  }
  sendDebugMessage(event) {
    if (this.debug) {
      const { level } = event;
      console[level](event.message, event);
      try {
        chrome.runtime.sendMessage(event);
      } catch (e) {
      }
    }
  }
  send(event) {
    this.sendDebugMessage(event);
  }
  getMeta() {
    return __spreadValues({
      version: VERSION,
      bid: this.bid,
      region: this.region,
      appId: this.appId
    }, getDeviceInfo());
  }
  info(message, data) {
    var _a;
    if (typeof ((_a = this._customLogger) == null ? void 0 : _a.info) === "function") {
      this._customLogger.info(message, data);
    }
    this.send({
      message,
      level: LogLevel.INFO,
      meta: this.getMeta(),
      data
    });
  }
  warn(message, data) {
    var _a;
    if (typeof ((_a = this._customLogger) == null ? void 0 : _a.warn) === "function") {
      this._customLogger.warn(message, data);
    }
    this.send({
      message,
      level: LogLevel.WARN,
      meta: this.getMeta(),
      data
    });
  }
  error(message, data) {
    var _a;
    if (typeof ((_a = this._customLogger) == null ? void 0 : _a.error) === "function") {
      this._customLogger.error(message, data);
    }
    this.send({
      message,
      level: LogLevel.ERROR,
      meta: this.getMeta(),
      data
    });
  }
  destruct() {
    var _a;
    if (typeof ((_a = this._customLogger) == null ? void 0 : _a.destruct) === "function") {
      this._customLogger.destruct();
    }
    this._isInitialized = false;
  }
  reportCUJ(name, status, data) {
    this._monitorModule.reportCUJ(name, status, data);
  }
}
var LoggingModule_default = new LoggingModule();
export {
  LoggingModule_default as default
};
